import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, 
  TableRow, TablePagination, Paper, Button, TextField, 
  Box, MenuItem, Select, InputLabel, FormControl
} from '@mui/material';
import amexOffers from '../services/amex_offers.service';

export default function AmexOffersDownloadPage() {
  const [offerFiles, setOfferFiles] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [orderBy, setOrderBy] = useState('username');
  const [orderDirection, setOrderDirection] = useState('asc');
  const [fileFormat, setFileFormat] = useState('type_csv'); // Default to CSV

  useEffect(() => {
    fetchOfferFiles(page + 1, rowsPerPage, keyword, orderBy, orderDirection, fileFormat);
  }, [page, rowsPerPage, keyword, orderBy, orderDirection, fileFormat]);

  const fetchOfferFiles = async (page, pageSize, keyword, orderBy, orderDirection, format) => {
    try {
      const response = await amexOffers.getOfferFiles(page, pageSize, keyword, orderBy, orderDirection, format);
      if (response.success) {
        setOfferFiles(response.result);
        setTotalCount(response.maxData);
      } else {
        console.error("Error fetching offer files:", response.message);
      }
    } catch (error) {
      console.error("Failed to fetch offer files:", error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };

  const handleKeywordChange = (event) => {
    setKeyword(event.target.value);
    setPage(0); // Reset to first page when keyword changes
  };

  const handleOrderByChange = (newOrderBy) => {
    const newDirection = orderBy === newOrderBy && orderDirection === 'asc' ? 'desc' : 'asc';
    setOrderBy(newOrderBy);
    setOrderDirection(newDirection);
    setPage(0); // Reset to first page when sorting changes
  };

  const handleDownload = (cardNo, fileName) => {
    amexOffers.downloadFile(cardNo, fileName);
  };

  const handleFormatChange = (event) => {
    setFileFormat(event.target.value);  // Update file format
    setPage(0);  // Reset to first page when format changes
  };

  return (
    <div style={{ marginTop: "20px", width: "80%", margin: "auto" }}>
      <h1>OFFER FILE MANAGER</h1>
      <Box mb={2} display="flex" alignItems="center">
        <TextField
          label="Search"
          variant="outlined"
          value={keyword}
          onChange={handleKeywordChange}
          style={{ marginRight: 8 }}
        />
        <FormControl variant="outlined" style={{ minWidth: 120, marginLeft: 8 }}>
          <InputLabel id="order-by-label">Order By</InputLabel>
          <Select
            labelId="order-by-label"
            value={orderBy}
            onChange={(event) => handleOrderByChange(event.target.value)}
            label="Order By"
          >
            <MenuItem value="username">Username</MenuItem>
            <MenuItem value="cardNo">Card Number</MenuItem>
          </Select>
        </FormControl>
        {/* File Format Dropdown */}
        <FormControl variant="outlined" style={{ minWidth: 120, marginLeft: 8 }}>
          <InputLabel id="file-format-label">File Format</InputLabel>
          <Select
            labelId="file-format-label"
            value={fileFormat}
            onChange={handleFormatChange}
            label="File Format"
          >
            <MenuItem value="type_csv">CSV</MenuItem>
            <MenuItem value="type_excel">Excel</MenuItem>
            <MenuItem value="type_pdf">PDF</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell onClick={() => handleOrderByChange('username')} style={{ cursor: 'pointer' }}>
                Username {orderBy === 'username' ? (orderDirection === 'asc' ? '▲' : '▼') : ''}
              </TableCell>
              <TableCell onClick={() => handleOrderByChange('cardNo')} style={{ cursor: 'pointer' }}>
                Card Number {orderBy === 'cardNo' ? (orderDirection === 'asc' ? '▲' : '▼') : ''}
              </TableCell>
              <TableCell>Download</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {offerFiles.map((file) => (
              <TableRow key={file.downloadLink}>
                <TableCell>{file.username}</TableCell>
                <TableCell>{file.cardNo}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleDownload(file.cardNo, file.downloadLink.split('/').pop())}
                  >
                    Download
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </div>
  );
}
